// 사내 알림 액션(rpc) — 설정 알림 탭의 채널 저장.
import { rpc } from "@/api/client";

export const saveNotifyChannels = (input: unknown) => rpc("notify/actions/saveNotifyChannels", input);
